import NumberSet from "components/common/NumberSet";
import Typography from "components/common/Typography";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { fetchDashboardReportAsync } from "../dashboard/HotelUserDashboard.slice";
import { getHotelUserDashboardInncode } from "../dashboard/HotelUserDashboardHelper";
import "./MyDashboard.scss";

const Statistics: React.FC = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const dateRangeFilter = useAppSelector((state) => state.hotelUserDashboardSlice.dateRangeFilter);
  const cardsSnapshot = useAppSelector((state) => state?.hotelUserDashboardSlice.statistics?.CARDS_SNAPSHOT?.[0]);
  const plansSnapshot = useAppSelector((state) => state?.hotelUserDashboardSlice.statistics?.PLANS_SNAPSHOT?.[0]);
  const externalHltId = searchParams.get("member");

  const innCode = getHotelUserDashboardInncode();

  useEffect(() => {
    if (innCode) {
      dispatch(
        fetchDashboardReportAsync({
          innCode,
          externalHltId: externalHltId || "",
          query: "PLANS_SNAPSHOT,CARDS_SNAPSHOT",
          ...(dateRangeFilter?.createdDateFrom && dateRangeFilter)
        })
      );
    }
  }, [innCode, dateRangeFilter]);

  return (
    <div className="statistics">
      <div className="statistics-number_set">
        {plansSnapshot && (
          <NumberSet
            variant="Dark"
            backgroundColor={tokens.Background.General.LightColor}
            title={"Plans"}
            snapShot={plansSnapshot}
          />
        )}

        {cardsSnapshot && <NumberSet variant="Light" title={"Actions"} snapShot={cardsSnapshot} />}
      </div>
      <div className="statistics-number_info">
        <Typography variant={"label"} changeVariant={false} color={tokens.Text.General.Tertiary}>
          *Last 90 Days
        </Typography>
      </div>
    </div>
  );
};

export default Statistics;
